import React, { useEffect, useMemo, useState } from "react";
import { useSelector } from "react-redux";

import { components } from "../components";
import { hooks } from "../hooks";
import { items } from "../items";
import { Routes, TabScreens } from "../routes";
import { RootState } from "../store";
import _ from "lodash";
import { actions } from "../store/actions";
import Enums from "../helpers/enums";
import utils from "../helpers/utils";
import constants from "../helpers/constants";

export const Order: React.FC = () => {
  const dispatch = hooks.useDispatch();
  const [opacity, setOpacity] = useState<number>(0);
  const [isMobile, setIsMobile] = useState(window.innerWidth < 600);

  hooks.useScrollToTop();
  hooks.useOpacity(setOpacity);
  hooks.useThemeColor("#F6F9F9", "#F6F9F9", dispatch);
  const navigate = hooks.useNavigate();

  const cartItems = useSelector((state: RootState) => state.cartReducer.cartItems);

  useEffect(() => {
    const handleResize = () => setIsMobile(window.innerWidth < 600);
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const totalCheckOutPrice = useMemo(() => {
    let totalPrice = 0;
    totalPrice += _.sumBy(cartItems, (item: any) => {
      if (item.type === Enums.comboType.quickCombo) {
        return (
          (item.price + item.totalCutomizedItemPrice + item.swappedPrice) *
          item.quantity
        );
      } else {
        let itemPrice =
          (item.price + item.totalCutomizedItemPrice) * item.quantity;
        if (item.options && item.options.length > 0) {
          itemPrice += item.options[0].price * item.quantity;
        }
        return itemPrice;
      }
    });
    return Number(totalPrice.toFixed(2));
  }, [cartItems]);

  const renderDishes = (): JSX.Element => {
    return (
      <section style={{ marginBottom: 20 }}>
        <ul style={{
          paddingTop: 20
        }}>
          {cartItems.map((cartItem: any, index: number) => {
            return (
              <items.OrderItem
                key={cartItem._id}
                index={index}
                isLast={index === cartItems.length - 1}
                item={cartItem}
              // isMandatory={isMandatory}
              />
            );
          })}
        </ul>
      </section>
    );
  };

  const renderSummary = (): JSX.Element => {
    return (
      <section
        style={{
          padding: 20,
          borderRadius: 10,
          marginBottom: 20,
          backgroundColor: "var(--white-color)",
          border: "1px solid var(--main-turquoise)",
        }}
      >
        <div className="row-center-space-between" style={{ marginBottom: 13 }}>
          <span
            className="t14"
            style={{ color: "var(--main-color)", fontWeight: 500 }}
          >
            Subtotal
          </span>
          <span className="t14" style={{ color: "var(--main-color)" }}>
            ${totalCheckOutPrice.toFixed(2)}
          </span>
        </div>
        <div className="row-center-space-between" style={{ marginBottom: 13 }}>
          <span className="t14" style={{ color: "var(--main-color)" }}>
            GST included
          </span>
          <span className="t14" style={{ color: "var(--main-color)" }}>
            {utils.formatCurrency(totalCheckOutPrice / constants.gstAmount)}
          </span>
        </div>
        <div
          className="row-center-space-between"
          style={{
            paddingBottom: 13,
            marginBottom: 20,
            borderBottom: "1px solid #DBE9F5",
          }}
        >
          {/* <span className='t14'>Delivery</span>
          <span className='t14'>${0}</span> */}
        </div>
        <div className="row-center-space-between">
          <h4>Total</h4>
          <h4>${totalCheckOutPrice.toFixed(2)}</h4>
        </div>
      </section>
    );
  };

  const renderButton = (): JSX.Element => {
    return (
      <components.Button
        text="Checkout"
        containerStyle={{ marginBottom: 10 }}
        onClick={() => {
          navigate(Routes.Checkout);
        }}
      />
    );
  };

  const renderContent = (): JSX.Element | null => {
    if (cartItems.length === 0) return null;

    return (
      <>
        <main className="container scrollable">{renderDishes()}</main>
        <section className="container" style={{ marginTop: 8 }}>
          {renderSummary()}
          {renderButton()}
        </section>
      </>
    );
  };

  const renderEmpty = (): JSX.Element | null => {
    if (cartItems.length === 0) {
      return (
        <main className="scrollable container">
          <section
            style={{
              paddingTop: "5%",
              paddingBottom: "14%",
              borderRadius: 10,
              marginTop: 10,
              backgroundColor: "var(--white-color)",
            }}
          >
            <img
              src="https://george-fx.github.io/dinehub_api/assets/images/02.jpg"
              alt="Empty cart"
              style={{
                width: isMobile ? "calc(100% - 120px)" : "calc(100% - 380px)",
                height: isMobile ? "calc(100% - 120px)" : "calc(100% - 380px)",
                marginBottom: 20,
                marginLeft: "auto",
                marginRight: "auto",
              }}
            />
            <h2
              style={{
                textAlign: "center",
                textTransform: "capitalize",
                marginBottom: 14,
              }}
            >
              Your cart is empty!
            </h2>
            <p className="t16" style={{ textAlign: "center" }}>
              Looks like you haven't made <br />
              your order yet.
            </p>
          </section>
        </main>
      );
    }

    return null;
  };

  const renderShopNowButton = (): JSX.Element | null => {
    if (cartItems.length > 0) return null;

    return (
      <section style={{ padding: "20px 20px 0 20px ", marginBottom: 20 }}>
        <components.Button
          text="Shop now"
          onClick={() => {
            dispatch(actions.setScreen(TabScreens.Home));
            navigate(Routes.TabNavigator);
          }}
        />
      </section>
    );
  };

  return (
    <div id="screen" style={{ opacity }}>
      {renderEmpty()}
      {renderContent()}
      {renderShopNowButton()}
    </div>
  );
};
